module.exports = __webpack_public_path__ + "promotion_highlight.png?34aedf79d843ccd796ec0b82ccf7a8c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotion_highlight.png
// module id = 996
// module chunks = 2